import { useState } from "react";
import { TextField } from "../../blocks/fields/TextField";
import { ConfirmationModal } from "../../elements/ConfirmationModal";
import { SaveViewModalProps } from "./SaveViewModal.types";

/** Names the search and saves it as a new view. */
export function SaveViewModal({ onSave, onClose }: SaveViewModalProps) {
  const [name, setName] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const save = async () => {
    setIsSubmitting(true);

    if (await onSave(name.trim())) {
      onClose();
      return;
    }

    setIsSubmitting(false);
  };

  return (
    <ConfirmationModal
      modalTitle="Save View"
      confirmText="Save"
      isSubmitting={isSubmitting}
      confirmDisabled={name.trim() === ""}
      onClose={onClose}
      onConfirm={save}
    >
      <TextField label="Name" name="save-view-name" value={name} onChange={setName} required />
    </ConfirmationModal>
  );
}
